import { useState, useCallback } from 'react';
import { apiService } from '../services/api';

export interface UseVideoDownloadReturn {
  isDownloading: boolean;
  downloadVideo: (taskId: string, filename?: string) => Promise<void>;
  downloadDirect: (taskId: string, filename?: string) => void;
  error: string | null;
}

export const useVideoDownload = (): UseVideoDownloadReturn => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadVideo = useCallback(async (taskId: string, filename?: string) => {
    try {
      setIsDownloading(true);
      setError(null);

      const blob = await apiService.downloadVideo(taskId);
      
      // Create download link
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `video_dubbed_${taskId}.mp4`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to download video');
    } finally {
      setIsDownloading(false);
    }
  }, []);

  const downloadDirect = useCallback((taskId: string, filename?: string) => {
    try {
      setError(null);
      const downloadUrl = apiService.getDownloadUrl(taskId);
      
      // Open in new tab for direct download
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = filename || `video_dubbed_${taskId}.mp4`;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to initiate download');
    }
  }, []);

  return {
    isDownloading,
    downloadVideo,
    downloadDirect,
    error,
  };
};
